import axios from "axios";
import { getAuthorizationToken } from "../config/user";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function updateAppConfig(data) {
  return axios({
    method: "Post",
    url: `${REACT_APP_API_URL}/update-app-version`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function getCurrentIosAppConfig() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/app-version?appType=IOSAPP`,

    headers: getAuthorizationToken(),
  });
}

function getCurrentAndroidAppConfig() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/app-version`,

    headers: getAuthorizationToken(),
  });
}

function getAiConfiguraion() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/ai-configuration`,

    headers: getAuthorizationToken(),
  });
}
function updateAiConfiguration(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-ai-configuration`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

export const appConfigServices = {
  updateAppConfig,
  getCurrentAndroidAppConfig,
  getCurrentIosAppConfig,
  getAiConfiguraion,
  updateAiConfiguration,
};
